<div #mapContainer id="map"></div>
<div style="top: 58px !important;" id="myModal" class="modal" aria-modal="true" role="dialog">
    <div class="modal-dialog">
        <div class="modal-content">
             <div class="modal-header text-white">
                Select Portfolio
                <!-- <button type="button" class="close text-white fa-2x" (click)="close()" data-dismiss="modal">&times;</button> -->
            </div>  
            <div class="modal-body p-2">
                <div class="row portfolioSelection">
                    <div class="col-md-12">
                       
                        <ul class="list-group list-group-flush">
                            <li class="list-group-item " (click)="getPortfolio('CD')">
                                <img src="https://dummyimage.com/30x30/5fa9f8/ffffff" alt=""> Consumer Durable Loans
                                <i class="fa-2x fa  fa-angle-right float-right"></i>
                            </li>
                            <li class="list-group-item " (click)="getPortfolio('TW')">
                                <img src="https://dummyimage.com/30x30/5fa9f8/ffffff" alt=""> Two Wheeler Loans
                                <i class="fa-2x fa  fa-angle-right float-right"></i>
                           </li>             
                           
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div  style="top: 330px !important; height: 50% !important;"  id="dealerList" class="modal" aria-modal="true" role="dialog">
    <div class="modal-dialog modal-md modal-dialog-scrollable">
        <div class="modal-content">
            <div class="modal-header text-white">
                Select Dealer
                <button type="button" class="close text-white fa-2x" (click)="close('dealerList')" data-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body p-2">
                <div class="row dealerSelection">
                    <div *ngFor="let data of dealerList;let i = index"  class="col-md-12">
                        <ul class="list-group list-group-flush">
                            <li class="list-group-item " (click)="locatemap(data)">
                                <img src="https://dummyimage.com/30x30/5fa9f8/ffffff" alt="">{{data.dealerName|titlecase}}
                                <i class="fa-2x fa  fa-angle-right float-right"></i>
                            </li>
                            <span *ngIf="isLastData(i)">
                            </span>    
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<loader *ngIf="loader"></loader>



